module.exports = __webpack_public_path__ + "static/media/logo-zalo.ed13866f.jpeg";